module.exports = __webpack_public_path__ + "static/img/22.ce0f5ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/22.png
// module id = hWDa
// module chunks = 7